import { render } from "./CertificateGeneratorIconFeedback.vue?vue&type=template&id=26e3fa45"
import script from "./CertificateGeneratorIconFeedback.vue?vue&type=script&lang=js"
export * from "./CertificateGeneratorIconFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__